import { KSA_POLICY } from './tables.js';

/**
 * Annual-leave entitlement (art. 109): 21 days, rising to 30 once the
 * employee has completed five consecutive years of service.
 *
 * Pure and table-driven; balance arithmetic (accrual, taken days) builds on
 * this in the leave SOP slice (P5).
 */
export interface AnnualLeaveEntitlement {
  readonly days: number;
  readonly ruleRef: string;
}

export function annualLeaveEntitlement(serviceYears: number): AnnualLeaveEntitlement {
  if (!Number.isFinite(serviceYears) || serviceYears < 0) {
    throw new RangeError(`serviceYears must be a non-negative number, got ${serviceYears}`);
  }
  const t = KSA_POLICY.annualLeave;
  return {
    days: serviceYears >= t.longServiceAfterYears ? t.longServiceDays : t.baseDays,
    ruleRef: t.ruleRef,
  };
}
